module.exports = __webpack_public_path__ + "static/media/placeholder-showimg.c4eb208a.jpg";